module.exports = __webpack_public_path__ + "static/img/new_thumb4.58c3108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_thumb4.jpg
// module id = Nd3O
// module chunks = 0